import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { renderShipmentCalculated } from '../../helpers/render-shipment-calculated'

export const marginRatioColumn: ShipmentColumn = {
    dataIndex: 'calculated',
    title: 'Коеф. нац.',
    width: 50,
    onCell: onCellStandard,
    render: renderShipmentCalculated(calculated =>
        Math.round((calculated?.marginRatio || 0) * 100) / 100
    ),
}
